import { latLongToCountry } from '@service-initiation/shared-data-access-google';
import { validateZipCode } from '@service-initiation/shared-utils-validators';
import { type Location } from '@service-initiation/tech-care-data-access-store';
import { ErrorType } from '@service-initiation/tech-care-data-access-tech-care-services';

import { type StepValidatorResult } from './types';
const ALLOWED_COUNTRY_CODES = ['US'];

export const validateZipcode = async (
  userInput: Location
): Promise<StepValidatorResult> => {
  const postalCode = userInput?.postalCode;
  const geoLocation = userInput?.geoLocation;
  const fullAddress = userInput?.fullAddress;

  if (!geoLocation && !fullAddress && !validateZipCode(postalCode)) {
    return { error: ErrorType.Error, isValid: false };
  } else {
    if (geoLocation) {
      const country = await latLongToCountry(
        geoLocation.latitude,
        geoLocation.longitude
      );

      return ALLOWED_COUNTRY_CODES.includes(country || '')
        ? { isValid: true }
        : { error: ErrorType.InvalidCountry, isValid: false };
    }
    return { isValid: true };
  }
};
